var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6186 12.9629C14.9604 12.6212 14.9605 12.0672 14.6189 11.7254L9.05201 6.15541C8.71039 5.81361 8.15637 5.81346 7.81457 6.15507C7.47277 6.49668 7.47261 7.0507 7.81423 7.39251L12.7626 12.3436L7.81148 17.292C7.46968 17.6336 7.46952 18.1876 7.81114 18.5294C8.15275 18.8712 8.70677 18.8714 9.04857 18.5298L14.6186 12.9629ZM-0.000242765 13.2151L13.9998 13.219L14.0003 11.469L0.000242765 11.4651L-0.000242765 13.2151Z",
    fill: "#424895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPurple);
export default __webpack_public_path__ + "static/media/arrow-right-purple.a7dcb5b7823ae850811f1df40b262b02.svg";
export { ForwardRef as ReactComponent };